import { queryOptions } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { Balance, CreateBalanceRequest } from '@/api/pending'
import { queryKeys } from '@/api/queryKeys'

export const balancesQuery = (condoId: number) =>
  queryOptions({
    queryKey: queryKeys.balances(condoId),
    queryFn: ({ signal }) =>
      api
        .get<Balance[]>('/condominiums/:id/balances', { params: { id: condoId }, signal })
        .then((d) => d ?? []),
  })

export const createBalance = (condoId: number, body: CreateBalanceRequest) =>
  api.post<Balance>('/condominiums/:id/balances', body, { params: { id: condoId } })

export const replaceBalance = (condoId: number, balanceId: number, body: CreateBalanceRequest) =>
  api.patch<Balance>('/condominiums/:id/balances/:balanceId', body, {
    params: { id: condoId, balanceId },
  })
